// Allow iframes in content to be wrapped in responsive code
import $ from 'jquery';

export default function iframer (selector = '.as-wysiwyg iframe', wrapperClass = 'media-video-wrapper') {
	if ($(selector).height() / $(selector).width() == .75){
		wrapperClass = 'media-video-wrapper media-video-wrapper--4x3';
	}
    $(selector).wrap(`<div class="${wrapperClass}"/>`);
}